import { useState } from 'react';
import Enllac from 'components/corporatiu/Enllac';
import Icona from 'components/corporatiu/ui/Icona';
import Text from 'components/corporatiu/Text';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import { getDataUTC, getSlug } from '@portal-internet/core';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatBasic.module.scss';

const DestacatBasic = (props) => {
    const {
        item,
        routePath,
        portal,
        className,
        testId,
        mostrarData,
        mostrarEntradeta,
        mostrarId = false,
        mostrarImatge,
        mostrarAvantitol,
        mostrarTitol = true,
        disposicio,
        durada = false,
        retallarEntradeta = false,
        estil,
        tema,
        tipusImatge = 'web_destacat',
        imatgeSrc = '',
        numColumnsRow = 0,
        objectFit = 'cover',
        icona = 'auto',
        mostrarLink = true
    } = props;

    const {
        id,
        titol,
        resum,
        entradeta,
        data_publicacio,
        imatges,
        videos,
        audios,
        domini,
        tipologia,
        avantitol,
        programes_radio,
        url,
        link,
        desc,
        permatitle
    } = item || props;

    const Tag = estil !== 'gridCercador' ? 'div' : ({ children }) => <>{children}</>;
    const Tag2 = estil !== 'gridCercador' ? ({ children }) => <>{children}</> : 'div';

    const [expandedEntradeta, setExpandedEntradeta] = useState(false);
    const entradeta_text = entradeta || '';
    const isLongEntradeta = entradeta_text.length > 210;
    const displayedEntradeta = expandedEntradeta || !isLongEntradeta ? entradeta_text : entradeta_text.substring(0, 210) + '...';

    const textAvantitol = avantitol || (programes_radio && programes_radio.length > 0 ? programes_radio[0].desc : '');
    const textTitol = titol || permatitle || desc;
    const route = {
        type: routePath,
        slug: textTitol,
        id: id,
        domini: domini,
        tipologia: tipologia,
        href: link || url
    };

    const stylesDestacat = clsx({
        [styles.destacatBasic]: true,
        [styles.retallarEntradeta]: retallarEntradeta,
        [styles[portal]]: !__isEmpty(portal),
        [styles[estil]]: !__isEmpty(estil),
        [styles[tema]]: !__isEmpty(tema),
        [className]: !__isEmpty(className),
        [styles.horitzontal]: disposicio === 'horitzontal',
        [styles['col' + numColumnsRow]]: numColumnsRow != null && numColumnsRow !== ''
    });

    if (mostrarTitol && !textTitol) {
        return <></>;
    }

    const ConditionalEnllac = mostrarLink
        ? ({ children, ...rest }) => <Enllac {...rest}>{children}</Enllac>
        : ({ children }) => <>{children}</>;

    let iconType = null;
    if (icona !== 'no') {
        if ((icona === 'auto' && videos) || icona === 'video') {
            iconType = 'play';
        } else if ((icona === 'auto' && audios) || icona === 'audio') {
            iconType = 'auriculars_ple';
        }
    }

    return (
        <div
            key={`destacat-basic-${id}`}
            className={stylesDestacat}
            {...(testId && { 'data-testid': testId })}
            {...(mostrarId && { id: `${getSlug(textTitol)}` })}
        >
            {mostrarImatge && (imatges || imatgeSrc) && (
                <ConditionalEnllac route={route} dataTestId='destacat-enllac' className={styles.enllac}>
                    <div className={styles.imatgeWrapper}>
                        <Imatge
                            imatges={imatges}
                            src={imatgeSrc}
                            className={styles.imatge}
                            tipus={tipusImatge}
                            numColumnsRow={numColumnsRow}
                            aria-hidden='true'
                            layout='fill'
                            priority={false}
                            objectFit={objectFit}
                            data-testid='destacat-img'
                        />
                        {iconType && mostrarImatge && (
                            <span className={styles.iconaMediaWrapper}>
                                <Icona icona={iconType} isBlanc={true} className={styles.iconaMedia} />
                            </span>
                        )}
                        {durada && mostrarImatge && (
                            <span className={styles.durada} data-testid='destacat-basic-durada'>
                                {durada}
                            </span>
                        )}
                    </div>
                </ConditionalEnllac>
            )}
            {/*{(mostrarEntradeta && entradeta) ||
                (mostrarTitol && textTitol && (*/}
            <Tag className={styles.contentWrapper}>
                <div className={styles.contentHead}>
                    {mostrarAvantitol && textAvantitol && (
                        <span className={styles.avantitol} data-testid='avantitol'>
                            {textAvantitol}
                        </span>
                    )}

                    {mostrarTitol && textTitol && (
                        <ConditionalEnllac route={route} dataTestId='destacat-enllac'>
                            <Text tag='div' className={styles.titol} text={textTitol} dataTestId='destacat-basic-titol' />
                        </ConditionalEnllac>
                    )}

                    {mostrarData && data_publicacio && (
                        <time
                            dateTime={getDataUTC(data_publicacio)}
                            className={styles.dataPub}
                            data-testid='destacat-basic-data-publicacio'
                        >
                            {data_publicacio.split(' ')[0]}
                        </time>
                    )}
                </div>
                <div className={styles.contentText}>
                    <Tag2 className={styles.contentTextElipsis}>
                        {resum && <Text className={styles.entradeta} tag='p' text={resum} />}
                        {mostrarEntradeta && entradeta && (
                            <>
                                {retallarEntradeta ? (
                                    <Text
                                        className={styles.entradeta}
                                        tag='p'
                                        text={displayedEntradeta}
                                        dataTestId='destacat-basic-entradeta'
                                    ></Text>
                                ) : (
                                    <Text
                                        className={styles.entradeta}
                                        tag='p'
                                        text={entradeta}
                                        dataTestId='destacat-basic-entradeta'
                                    ></Text>
                                )}
                                {isLongEntradeta && !expandedEntradeta && retallarEntradeta && (
                                    <button
                                        onClick={() => setExpandedEntradeta(true)}
                                        className={styles.mesLink}
                                        aria-label="Llegir tota l'entradeta"
                                    >
                                        Més
                                    </button>
                                )}
                            </>
                        )}
                    </Tag2>
                </div>
            </Tag>
            {/*))}*/}
        </div>
    );
};

export default DestacatBasic;
